exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coupon[data-v-58d1dd46]{background-color:#eee;padding:.53333333rem}", ""]);

// exports
